/* Size memory — the shop remembers which size you take.

   Why: shoppers open about four product pages per visit and spend ~9 seconds on
   each, because half the catalogue's size options are gone and stock runs one
   unit per size. Every one of those visits asks the same question. Answering it
   once, then carrying the answer everywhere, is the only change that reduces
   the NUMBER of those visits rather than polishing each one.

   Captured silently from the first size a shopper picks — no prompt, no
   settings panel. Expressed in one idiom in two places:
     · product page — the tile for your size is ringed (a fill still means
       "selected", so the two never read as the same state)
     · collection card — your number is inked inside the otherwise soft
       mono size line, so it pops while scanning a grid

   Degrades to the previous behaviour when nothing is stored, and localStorage
   is wrapped because Safari private mode throws on write. */
(function () {
  var KEY = 'ss:size';
  var root = document.documentElement;

  function read() {
    try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; }
  }

  function euOf(el) {
    var eu = el.querySelector('.size__eu');
    return eu ? eu.textContent.trim() : '';
  }

  function apply() {
    var mine = read();
    /* Exposed on <html> so CSS or analytics can branch on it without re-reading
       storage, and so the state is visible when debugging a session replay. */
    if (mine) root.setAttribute('data-my-size', mine); else root.removeAttribute('data-my-size');

    var tiles = Array.prototype.slice.call(document.querySelectorAll('.sizes .size'));
    var mineTile = null;
    tiles.forEach(function (b) {
      var hit = !!mine && euOf(b) === mine;
      b.classList.toggle('is-mine', hit);
      if (hit) mineTile = b;
    });

    Array.prototype.slice.call(document.querySelectorAll('.card__size')).forEach(function (s) {
      s.classList.toggle('is-mine', !!mine && s.getAttribute('data-size') === mine);
    });

    /* Product page: if the size we remember is sold out HERE, say so before the
       shopper hunts for it, and point at the alternatives further down rather
       than leaving the tap as a dead end. */
    var note = document.querySelector('[data-my-size-note]');
    if (note) {
      var gone = mineTile && mineTile.getAttribute('aria-disabled') === 'true';
      if (gone && window.theme && theme.t) {
        var label = note.querySelector('[data-my-size-text]');
        if (label) label.textContent = theme.t('product.my_size_gone', { size: mine });
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    /* Related products the shopper can actually buy move to the front of the
       row. Six are rendered and four are shown, so this promotes a buyable pair
       into view rather than merely re-sorting what was already visible.

       The nodes are MOVED rather than given a CSS `order`: the row is capped
       with :nth-child, which counts DOM position and would otherwise hide
       whichever cards happened to be authored fifth and sixth regardless of
       where `order` painted them. Prepending in reverse is idempotent — matches
       keep their relative order however many times this runs. */
    var grid = document.querySelector('.related__grid');
    if (grid && mine) {
      Array.prototype.slice.call(grid.querySelectorAll('.card'))
        .filter(function (c) { return (c.getAttribute('data-sizes') || '').split('|').indexOf(mine) > -1; })
        .reverse()
        .forEach(function (c) { grid.insertBefore(c, grid.firstChild); });
    }
  }

  /* Capture: any real size pick, on any product page. Sold-out tiles are
     aria-disabled and must not overwrite a working size. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.sizes .size');
    if (!b || b.hasAttribute('disabled') || b.getAttribute('aria-disabled') === 'true') return;
    var v = euOf(b);
    if (!v) return;
    try { localStorage.setItem(KEY, v); } catch (err) {}
    apply();
  });

  /* Theme Editor and cart re-renders swap section markup out from under us. */
  document.addEventListener('shopify:section:load', apply);

  apply();
})();
